declare var moment: any;

import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'sb-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss'],
  standalone: false
})
export class DateTimePickerComponent implements OnInit, OnChanges {

  @Input() modelDateTime: any; // moment object or null
  @Output() modelDateTimeChange = new EventEmitter<any>();
  @Input() required: boolean = true;
  @Input() minDateTime: any; // moment object or null
  @Input() maxDateTime: any; // moment object or null
  @Input() minuteStep: number = 1;
  @Input() isReadonly: boolean = false;
  @Input() isDisabled: boolean = false;

  internalDate: NgbDateStruct | null = null;
  selectedHour: number | null = null;
  selectedMinute: number | null = null;
  hours: Array<{ id: number; label: string }> = [];
  minutes: Array<{ id: number; label: string }> = [];

  get timeSelectionDisabled(): boolean {
    return !this.internalDate;
  }

  get ngbMinDate(): NgbDateStruct | null {
    return this.minDateTime ? this.momentToNgbDate(this.minDateTime) : null;
  }

  get ngbMaxDate(): NgbDateStruct | null {
    return this.maxDateTime ? this.momentToNgbDate(this.maxDateTime) : null;
  }

  ngOnInit(): void {
    this.buildTimeOptions();
    this.syncFromModel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.modelDateTime && !changes.modelDateTime.firstChange) {
      this.syncFromModel();
    }
    if (changes.minuteStep && !changes.minuteStep.firstChange) {
      this.buildTimeOptions();
    }
    if (changes.required && !changes.required.firstChange) {
      this.buildTimeOptions();
    }
  }

  onDateChange(): void {
    this.emitChange();
  }

  onTimeChange(): void {
    this.emitChange();
  }

  isHourDisabled(hour: number): boolean {
    if (hour < 0 || !this.internalDate) return false;
    if (this.minDateTime && this.isSameDay(this.internalDate, this.minDateTime) && hour < this.minDateTime.hour()) return true;
    if (this.maxDateTime && this.isSameDay(this.internalDate, this.maxDateTime) && hour > this.maxDateTime.hour()) return true;
    return false;
  }

  isMinuteDisabled(minute: number): boolean {
    if (minute < 0 || !this.internalDate) return false;
    if (this.minDateTime && this.isSameDay(this.internalDate, this.minDateTime)
      && this.selectedHour === this.minDateTime.hour() && minute < this.minDateTime.minute()) return true;
    if (this.maxDateTime && this.isSameDay(this.internalDate, this.maxDateTime)
      && this.selectedHour === this.maxDateTime.hour() && minute > this.maxDateTime.minute()) return true;
    return false;
  }

  private buildTimeOptions(): void {
    const step = this.minuteStep || 1;

    this.hours = [];
    if (!this.required) {
      this.hours.push({ id: -1, label: '  ' });
    }
    for (let i = 0; i < 24; i++) {
      this.hours.push({ id: i, label: ('0' + i).slice(-2) });
    }

    this.minutes = [];
    if (!this.required) {
      this.minutes.push({ id: -1, label: '  ' });
    }
    for (let i = 0; i < 60; i += step) {
      this.minutes.push({ id: i, label: ('0' + i).slice(-2) });
    }
  }

  private syncFromModel(): void {
    if (!this.modelDateTime) {
      this.internalDate = null;
      this.selectedHour = this.required ? 0 : -1;
      this.selectedMinute = this.required ? 0 : -1;
      return;
    }
    this.internalDate = this.momentToNgbDate(this.modelDateTime);
    this.selectedHour = this.modelDateTime.hour();
    this.selectedMinute = this.modelDateTime.minute();
  }

  private emitChange(): void {
    if (!this.internalDate || this.selectedHour == null || this.selectedHour < 0
      || this.selectedMinute == null || this.selectedMinute < 0) {
      if (!this.required) {
        this.modelDateTimeChange.emit(null);
      }
      return;
    }
    const newMoment = moment.utc({
      year: this.internalDate.year,
      month: this.internalDate.month - 1,
      date: this.internalDate.day,
      hour: this.selectedHour,
      minute: this.selectedMinute
    });
    this.modelDateTimeChange.emit(newMoment);
  }

  private momentToNgbDate(m: any): NgbDateStruct {
    return { year: m.year(), month: m.month() + 1, day: m.date() };
  }

  private isSameDay(ngbDate: NgbDateStruct, momentDate: any): boolean {
    return ngbDate.year === momentDate.year()
      && ngbDate.month === momentDate.month() + 1
      && ngbDate.day === momentDate.date();
  }
}
